// Lista curada dos comandos do RNPlugin pra pagina publica /comandos.
//
// "estavel": ja confirmado com build + teste real (ver RNPlugin-Plugin/ROADMAP.md,
// secao "Ja implementados"). "novo": codado e presente no instalador mais
// recente, mas ainda em validacao — mostrado com selo "Novo" em vez de
// escondido, pra nao prometer estabilidade que ainda nao foi confirmada.
//
// Atualizar esta lista a cada release que adiciona/confirma comandos.

export const categorias = [
  { id: 'geometria', nome: 'Geometria e Alinhamento', emoji: '📐' },
  { id: 'perfil', nome: 'Perfil e Seção', emoji: '📈' },
  { id: 'corredor', nome: 'Corredor e Assembly', emoji: '🛣️' },
  { id: 'rotulos', nome: 'Pontos e Rótulos', emoji: '🏷️' },
  { id: 'produtividade', nome: 'Produtividade', emoji: '⚡' },
  { id: 'documentacao', nome: 'Exportação e Documentação', emoji: '📄' },
  { id: 'mapas', nome: 'Mapas e Georreferenciamento', emoji: '🗺️' },
];

export const comandos = [
  // ---- Geometria e Alinhamento ----
  {
    nome: 'PolyXL',
    categoria: 'geometria',
    status: 'estavel',
    destaque: true,
    descricao:
      'Desenha polylines por interseção de tangentes ou ponto a ponto, com desfazer dedicado — sem precisar sair calculando cruzamento na mão.',
  },
  {
    nome: 'Explodir e Copiar',
    categoria: 'geometria',
    status: 'estavel',
    descricao:
      'Explode uma cópia da entidade selecionada sem tocar na original — útil pra extrair geometria de blocos/polylines sem perder o objeto de origem.',
  },
  {
    nome: 'Comandos Rápidos de Coordenada',
    categoria: 'geometria',
    status: 'estavel',
    descricao:
      'Família de comandos transparentes (digitados no meio de LINE, POLYLINE etc.) que convertem um clique em Profile View ou Section View direto pra coordenada de planta.',
  },
  {
    nome: 'Alinhamento → Polyline',
    categoria: 'geometria',
    status: 'novo',
    descricao:
      'Gera a polyline em planta equivalente a um Alinhamento com um clique — sem precisar reconstruir a geometria manualmente.',
  },
  {
    nome: 'Polyline 3D → Alinhamento + Perfil',
    categoria: 'geometria',
    status: 'novo',
    destaque: true,
    descricao:
      'Cria um Alinhamento e o Perfil correspondente direto de uma polyline 3D desenhada em planta — ideal pra importar levantamentos de campo.',
  },

  // ---- Perfil e Seção ----
  {
    nome: 'Perfil → Polyline',
    categoria: 'perfil',
    status: 'novo',
    descricao:
      'Converte a linha de um Perfil numa polyline editável dentro da Profile View, ligando PVI a PVI.',
  },
  {
    nome: 'Polyline → Perfil',
    categoria: 'perfil',
    status: 'novo',
    descricao:
      'O caminho inverso: desenhe uma polyline dentro da Profile View e transforme ela num Perfil de verdade, pronto pra usar no projeto.',
  },
  {
    nome: 'Perfis em Lote',
    categoria: 'perfil',
    status: 'novo',
    destaque: true,
    descricao:
      'Gera perfis de superfície em vários alinhamentos de uma vez só, sem repetir o comando nativo alinhamento por alinhamento.',
  },
  {
    nome: 'Profile Views em Lote',
    categoria: 'perfil',
    status: 'novo',
    descricao:
      'Cria as Profile Views de vários alinhamentos numa única operação.',
  },

  // ---- Corredor e Assembly ----
  {
    nome: 'Zoom Região / Assembly',
    categoria: 'corredor',
    status: 'estavel',
    destaque: true,
    descricao:
      'Passe o mouse sobre o corredor pra destacar cada região, clique pra confirmar e o RNPlugin aplica o zoom direto no Assembly daquele trecho — inclusive em outra viewport.',
  },
  {
    nome: 'Renomear Regiões',
    categoria: 'corredor',
    status: 'novo',
    descricao:
      'Renomeia todas as regiões de um Corredor de uma vez, usando o nome do Assembly aplicado em cada uma como referência.',
  },
  {
    nome: 'Apagar Assemblies Sem Uso',
    categoria: 'corredor',
    status: 'novo',
    descricao:
      'Limpa do desenho os Assemblies que não estão aplicados em nenhuma região de nenhum Corredor — desenho mais leve, sem risco de apagar o que está em uso.',
  },
  {
    nome: 'Adicionar Nome aos Assemblies',
    categoria: 'corredor',
    status: 'novo',
    descricao: 'Rotula automaticamente os Assemblies do desenho pelo nome.',
  },
  {
    nome: 'Superfícies de Corredor em Lote',
    categoria: 'corredor',
    status: 'novo',
    descricao:
      'Extrai as superfícies de vários corredores de uma vez, sem repetir o processo corredor por corredor.',
  },
  {
    nome: 'Criar Superfícies em Lote',
    categoria: 'corredor',
    status: 'novo',
    descricao:
      'Gera superfícies a partir de múltiplos corredores numa única execução.',
  },
  {
    nome: 'Sample Lines em Lote',
    categoria: 'corredor',
    status: 'novo',
    descricao:
      'Cria grupos de Sample Line em vários alinhamentos de uma só vez.',
  },
  {
    nome: 'Copiar Parâmetros de Subassembly',
    categoria: 'corredor',
    status: 'novo',
    descricao:
      'Copia os parâmetros configurados de um Subassembly pra outros, sem reconfigurar manualmente cada um.',
  },
  {
    nome: 'Localizar e Substituir Parâmetros',
    categoria: 'corredor',
    status: 'novo',
    descricao:
      'Localiza e substitui valores de parâmetros de Subassembly em massa no corredor.',
  },
  {
    nome: 'Copiar Padrão de Talude',
    categoria: 'corredor',
    status: 'novo',
    descricao:
      'Copia os Slope Patterns configurados num corredor de outro desenho .dwg para os corredores do desenho atual.',
  },

  // ---- Pontos e Rótulos ----
  {
    nome: 'Label de Entidade Universal',
    categoria: 'rotulos',
    status: 'novo',
    destaque: true,
    descricao:
      'Cria labels de estaca/offset pra qualquer entidade suportada — linha, polyline, arco, bloco, ponto, CogoPoint ou estrutura — num único fluxo, com filtro por layer e por tipo.',
  },
  {
    nome: 'Inverter Labels em Massa',
    categoria: 'rotulos',
    status: 'novo',
    descricao:
      'Inverte a orientação de múltiplos labels de uma vez, sem precisar clicar um por um.',
  },
  {
    nome: 'Selecionar por Texto',
    categoria: 'rotulos',
    status: 'novo',
    descricao:
      'Seleciona entidades do desenho a partir de um trecho de texto — útil pra achar tudo relacionado a um nome ou código específico.',
  },

  // ---- Produtividade ----
  {
    nome: 'Renumerar Tags',
    categoria: 'produtividade',
    status: 'estavel',
    descricao:
      'Renumera automaticamente as tags do desenho seguindo a ordem que você define, sem repetição nem gaps.',
  },

  // ---- Exportação e Documentação ----
  {
    nome: 'Nota de Serviço',
    categoria: 'documentacao',
    status: 'estavel',
    destaque: true,
    descricao:
      'Gera a nota de serviço de vários tipos de entidade em relação ao alinhamento, pronta pra conferência e memorial.',
  },
  {
    nome: 'Exportar Tabela Civil 3D',
    categoria: 'documentacao',
    status: 'novo',
    destaque: true,
    descricao:
      'Exporta qualquer tabela do Civil 3D — nativa ou dos "Schedule Tables" (Alignment/Legend/Point/Parcel) — direto pra uma planilha Excel organizada.',
  },

  // ---- Mapas e Georreferenciamento ----
  {
    nome: 'Street View Integrado',
    categoria: 'mapas',
    status: 'novo',
    destaque: true,
    descricao:
      'Clique uma posição e uma direção no desenho e o Street View abre numa janela dentro do próprio AutoCAD, já apontado pro lugar certo — e continua acompanhando conforme você anda pela rua ali dentro.',
  },
];

// Comandos com mais apelo de venda primeiro (Street View, labels, exportação
// etc.), resto na sequência original — usado como ordem padrão da página de
// comandos e como preview na Homepage.
export const comandosOrdenados = [
  ...comandos.filter((c) => c.destaque),
  ...comandos.filter((c) => !c.destaque),
];

// Só os destaques, pro preview curto da Homepage.
export const destaques = comandos.filter((c) => c.destaque);
